module.exports = __webpack_public_path__ + "static/media/phone_9.c26dafd2.png";